import { render, staticRenderFns } from "./Zjld.vue?vue&type=template&id=9666e28a&scoped=true"
import script from "./Zjld.vue?vue&type=script&lang=js"
export * from "./Zjld.vue?vue&type=script&lang=js"
import style0 from "./Zjld.vue?vue&type=style&index=0&id=9666e28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9666e28a",
  null
  
)

export default component.exports